// extracted by mini-css-extract-plugin
export var divider = "_dy-7";
export var itemsToggle = "_dy-8";
export var mergeModal = "_dy-1";
export var optionCard = "_dy-4";
export var radioGroup = "_dy-6";
export var radioOption = "_dy-0";
export var selected = "_dy-5";
export var shipmentOptions = "_dy-2";
export var tableOptions = "_dy-3";